import { createContext, useContext } from 'react';

export const McpAppContext = createContext(null);

export function useMcpApp() {
  return useContext(McpAppContext);
}
